// @flow

import { connect } from 'react-redux';
import { isSourceLoaderShow } from '../../selectors';
import { hasSources } from '../../../list/selectors';
import { isSemUrlSelector } from '../../../../Serp/selectors';
import SourceLoaderSwitch from '.';

type MapStateToProps = {
  isShow: boolean,
};

function mapStateToProps(state: Object): MapStateToProps {
  const isSemUrl = isSemUrlSelector(state);

  return {
    isShow: isSourceLoaderShow(state) && hasSources(state) && !isSemUrl,
  };
}

const SourceLoaderSwitchContainer = connect(mapStateToProps)(SourceLoaderSwitch);

SourceLoaderSwitchContainer.displayName = 'SourceLoaderSwitchContainer';

export default SourceLoaderSwitchContainer;



// WEBPACK FOOTER //
// ./app/Sources/loader/components/SourceLoaderSwitch/container.js